<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_vi"></a><a id="page_vii"></a><em>Contents</em></h2>
<p class="toc-frontt"><a class="nounder" href="#/xhtml/foreword#for">Foreword, by Michael Fellman</a></p>
<p class="toc-front"><a class="nounder" href="#/xhtml/preface#pre">Preface</a></p>
<p class="toc-chapter"><a class="nounder" href="#/xhtml/cartesdevisite#car"><em>Cartes de Visite</em></a></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/notes#not" title="Link target outside of Sample">Notes</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/references#ref" title="Link target outside of Sample">References</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc-back"><span class="nounder" href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?58658f0c